import { useEffect } from 'react';
import { Col, Row } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { StyledPageWrapper } from 'components/new-ui/base/wrappers/styles';
import FormContent from 'components/new-ui/composed/multistep-form/FormContent';
import { MultiStepFormProvider } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import { StepsSidebar } from 'components/new-ui/composed/multistep-form/StepsSidebar';
import { getStepsConfig } from './components/create-job/stepsConfig';
import CreateJobPageHeader from './components/create-job/CreateJobPageHeader';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { createJobInitialValues } from './types';
import useSession from 'hooks/useSession';
import { checkCanAssignJobs, checkIsFreightAdmin, checkIsFreightForwarder } from 'config/roles/roles';

const CreateJobPage = () => {
    const { setBreadcrumbRoutes } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const { userInfo } = useSession();

    const teamId = searchParams.get('teamId');

    const isFreightForwarder = checkIsFreightForwarder(userInfo);
    const isFreightAdmin = checkIsFreightAdmin(userInfo);
    const canAssignJobs = checkCanAssignJobs(userInfo);
    const isUnderTeam = Boolean(teamId);

    useEffect(() => {
        setBreadcrumbRoutes([
            {
                breadcrumbName: 'Home',
                path: '/home',
            },
            {
                breadcrumbName: 'Jobs',
                path: '../jobs',
            },
            {
                breadcrumbName: 'Create Job',
                path: '',
            },
        ]);
    }, [setBreadcrumbRoutes]);

    return (
        <MultiStepFormProvider
            initialValues={createJobInitialValues}
            steps={getStepsConfig({ isFreightForwarder, isFreightAdmin, canAssignJobs, isUnderTeam })}
        >
            <StyledPageWrapper>
                <CreateJobPageHeader />
                <Row gutter={20} style={{ marginTop: 32 }}>
                    <Col style={{ maxWidth: 210 }} sm={24} md={6}>
                        <StepsSidebar />
                    </Col>
                    <Col sm={24} md={18}>
                        <FormContent />
                    </Col>
                </Row>
            </StyledPageWrapper>
        </MultiStepFormProvider>
    );
};

export default CreateJobPage;
